import { render } from "./Adminview.vue?vue&type=template&id=783d03a4&scoped=true"
import script from "./Adminview.vue?vue&type=script&lang=js"
export * from "./Adminview.vue?vue&type=script&lang=js"

import "./Adminview.vue?vue&type=style&index=0&id=783d03a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783d03a4"]])

export default __exports__